// Streaming SHA-256 of a File via hash-wasm. WebCrypto's digest() needs the whole
// file in one ArrayBuffer — a 500 MB video would kill mobile Safari — so we feed
// 8 MB slices into a WASM hasher instead. One shared instance, callers hash
// sequentially (the uploader does).
import { createSHA256 } from 'hash-wasm';

const CHUNK = 8 * 1024 * 1024;
let hasherPromise = null;

// onProgress(bytesHashed) fires per chunk — hashing a multi-GB video takes long
// enough on a phone that the UI needs something to move.
export async function sha256File(file, onProgress) {
	hasherPromise = hasherPromise ?? createSHA256();
	const hasher = await hasherPromise;
	hasher.init();
	for (let offset = 0; offset < file.size; offset += CHUNK) {
		const buf = await file.slice(offset, offset + CHUNK).arrayBuffer();
		hasher.update(new Uint8Array(buf));
		onProgress?.(Math.min(offset + CHUNK, file.size));
	}
	return hasher.digest('hex');
}
